<template>
  <footer class="modern-footer">
    <!-- 服务保障栏 -->
    <div class="footer-service-bar">
      <div class="container service-inner">
        <div class="service-item">
          <i class="el-icon-document-checked"></i>
          <div class="text-content">
            <h4>增值税专用发票</h4>
            <p>开具税点13%的增值税专用发票</p>
          </div>
        </div>
        <div class="service-item">
          <i class="el-icon-truck"></i>
          <div class="text-content">
            <h4>工业品全国配送/多仓发货</h4>
            <p>港澳台及特殊商品除外</p>
          </div>
        </div>
        <div class="service-item">
          <i class="el-icon-refresh"></i>
          <div class="text-content">
            <h4>7天无理由退换货</h4>
            <p>企业定制类产品除外</p>
          </div>
        </div>
        <div class="service-item contact-info">
          <div class="contact-line">
            <i class="el-icon-time"></i>
            <span>工作时间：{{ shopSettings.workingHours }}</span>
          </div>
          <div class="contact-line">
            <i class="el-icon-phone"></i>
            <span>售后电话：{{ shopSettings.aftersalesPhone }}</span>
          </div>
          <div class="contact-line">
            <i class="el-icon-message"></i>
            <span>售后邮箱：{{ shopSettings.aftersalesEmail }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="container footer-content">
      <!-- 品牌故事区 -->
      <div class="footer-brand">
        <h2 class="brand-logo">HALOMRO</h2>
        <p class="brand-desc">成为领先的工业品数字化供应链平台。<br>用科技重塑工业供应链，让企业采购更安全、更高效、更可靠。</p>
        <!-- <div class="social-links">
          <a href="#" class="social-item"><i class="el-icon-phone"></i></a>
          <a href="#" class="social-item"><i class="el-icon-chat-dot-round"></i></a>
          <a href="#" class="social-item"><i class="el-icon-monitor"></i></a>
        </div> -->
      </div>

      <!-- 链接矩阵 -->
      <div class="links-matrix">
        <div 
          v-for="group in helpGroups" 
          :key="group.id" 
          class="link-group"
        >
          <h4>{{ group.title }}</h4>
          <ul>
            <li v-for="item in group.children" :key="item.id">
              <a href="javascript:void(0)" @click="handleLinkClick(item)">{{ item.title }}</a>
            </li>
          </ul>
        </div>
        
        <!-- 如果加载失败或为空时的占位 -->
        <template v-if="helpGroups.length === 0">
          <div class="link-group">
            <h4>购物指南</h4>
            <ul>
              <li><a href="#">购物流程</a></li>
              <li><a href="#">会员介绍</a></li>
              <li><a href="#">常见问题</a></li>
            </ul>
          </div>
          <div class="link-group">
            <h4>配送服务</h4>
            <ul>
              <li><a href="#">上门自提</a></li>
              <li><a href="#">211限时达</a></li>
              <li><a href="#">配送查询</a></li>
            </ul>
          </div>
          <div class="link-group">
            <h4>售后保障</h4>
            <ul>
              <li><a href="#">售后政策</a></li>
              <li><a href="#">价格保护</a></li>
              <li><a href="#">退款说明</a></li>
            </ul>
          </div>
        </template>
      </div>

      <!-- 服务入口 (二维码) -->
      <div class="footer-contact">
        <div class="qr-container">
          <div class="qr-item">
            <div class="qr-box">
              <img :src="shopSettings.mpQrCode" alt="小程序" />
            </div> 
            <span>小程序</span>
          </div>
          <div class="qr-item">
            <div class="qr-box">
              <img :src="shopSettings.wechatQrCode " alt="客服微信" />
            </div>
            <span>客服微信</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部保障栏 -->
    <div class="footer-bottom-bar">
      <div class="container bar-inner">
         <a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备2021037698号-11</a >
      </div>
    </div>
  </footer>
</template>

<script>
import { getHelpTree } from '@/api/helpguide'
import { getPublicConfig } from '@/api/settings'

export default {
  name: 'Footer',
  data() {
    return {
      helpGroups: [],
      shopSettings: {
        workingHours: '',
        aftersalesPhone: '',
        aftersalesEmail: '',
        mpQrCode: '',
        wechatQrCode: ''
      }
    }
  },
  created() {
    this.fetchHelpTree()
    this.fetchShopSettings()
  },
  methods: {
    async fetchHelpTree() {
      try {
        const res = await getHelpTree()
        if (res.code === 200) {
          this.helpGroups = res.data
        }
      } catch (error) {
        console.error('获取帮助指南失败:', error)
      }
    },
    async fetchShopSettings() {
      const keys = [
        { key: 'shop.working.hours', field: 'workingHours' },
        { key: 'shop.aftersales.phone', field: 'aftersalesPhone' },
        { key: 'shop.aftersales.email', field: 'aftersalesEmail' },
        { key: 'shop.mp.qrcode', field: 'mpQrCode' },
        { key: 'shop.wechat.qrcode', field: 'wechatQrCode' }
      ]

      try {
        const results = await Promise.allSettled(
          keys.map(item => getPublicConfig(item.key))
        )

        results.forEach((res, index) => {
          if (res.status === 'fulfilled' && res.value.code === 200) {
            const field = keys[index].field
            let value = res.value.msg // 修改：从 res.value.data 改为 res.value.msg
            
            // 如果是二维码图片，且是相对路径，则补全域名
            if ((field === 'mpQrCode' || field === 'wechatQrCode') && value && !value.startsWith('http')) {
              value = process.env.VUE_APP_BASE_API + value
            }
            
            this.shopSettings[field] = value
          }
        })
      } catch (error) {
        console.error('获取商城设置失败:', error)
      }
    },
    handleLinkClick(item) {
      if (item.linkType === 1 && item.linkUrl) {
        window.open(item.linkUrl, '_blank')
      } else {
        this.$router.push(`/help/${item.id}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modern-footer {
  background: #111827;
  color: rgba(255,255,255,0.8);
  padding-top: 0; // 修改：移除顶部内边距，因为增加了服务栏
  margin-top: 60px;

  .container {
    width: 1400px;
    max-width: 95%;
    margin: 0 auto;
  }

  /* 服务保障栏样式 */
  .footer-service-bar {
    border-bottom: 1px solid rgba(255,255,255,0.1);
    padding: 60px 0;
    margin-bottom: 60px;

    .service-inner {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .service-item {
      flex: 1;
      display: flex;
      align-items: center;
      padding: 0 40px;
      border-right: 1px solid rgba(255,255,255,0.1);

      &:last-child {
        border-right: none;
      }

      i {
        font-size: 32px;
        color: #d97706;
        margin-right: 20px;
      }

      .text-content {
        h4 {
          color: #d97706;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 8px;
        }
        p {
          font-size: 14px;
          color: rgba(255,255,255,0.4);
          margin: 0;
        }
      }

      &.contact-info {
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        gap: 10px;

        .contact-line {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #d97706;

          i {
            font-size: 16px;
            margin-right: 10px;
          }
          span {
            font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, STHeitiSC-Light, Arial, sans-serif;
          }
        }
      }
    }
  }

  .footer-content {
    display: flex;
    justify-content: space-between;
    padding-bottom: 60px;
    gap: 40px;
  }

  /* 品牌区 */
  .footer-brand {
    flex: 1.5;
    .brand-logo {
      font-size: 28px;
      font-weight: 900;
      color: #fff;
      margin-bottom: 20px;
      span { color: #d97706; }
    }
    .brand-desc {
      font-size: 14px;
      line-height: 1.8;
      color: rgba(255,255,255,0.5);
      margin-bottom: 25px;
      max-width: 320px;
    }
  }

  /* 链接区 */
  .links-matrix {
    flex: 3;
    display: flex;
    justify-content: space-around;
    
    .link-group {
      h4 {
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 25px;
      }
      ul {
        list-style: none;
        padding: 0;
        li {
          margin-bottom: 12px;
          a {
            color: rgba(255,255,255,0.4);
            font-size: 14px;
            text-decoration: none;
            transition: all 0.2s;
            &:hover { color: #d97706; padding-left: 5px; }
          }
        }
      }
    }
  }

  /* 客服与小程序 (现改为二维码展示) */
  .footer-contact {
    flex: 1.5;
    .qr-container {
      display: flex;
      gap: 30px;
      justify-content: flex-end;

      .qr-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;

        .qr-box {
          background: #fff;
          padding: 8px;
          border-radius: 8px;
          transition: all 0.3s ease;
          &:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 20px rgba(0,0,0,0.3);
          }
          img {
            width: 110px;
            height: 110px;
            display: block;
            object-fit: contain;
          }
        }

        span {
          font-size: 14px;
          color: rgba(255,255,255,0.6);
          font-weight: 500;
        }
      }
    }
  }

  /* 底部平铺栏 */
  .footer-bottom-bar {
    background: #000;
    padding: 20px 0;
    font-size: 13px;
    color: rgba(255,255,255,1);

    .bar-inner {
      text-align: center;
    }
  }
}

@media (max-width: 991px) {
  .footer-service-bar {
    padding: 30px 0;
    .service-inner {
      flex-direction: column;
      gap: 30px;
    }
    .service-item {
      width: 100%;
      border-right: none;
      border-bottom: 1px solid rgba(255,255,255,0.1);
      padding: 0 0 20px 0;
      &:last-child { border-bottom: none; }
    }
  }
  .footer-content {
    flex-direction: column;
    text-align: center;
    .brand-desc { margin: 0 auto 25px; }
    .footer-contact {
      .qr-container {
        justify-content: center;
      }
    }
    .links-matrix { margin: 40px 0; }
  }
}
</style>
